export const ectMessageCodes = {
  CREDIT_EXCEEDED: '02',
  DROP_BOX_ESTIMATED_PICKUP_DATE_TOOLTIP: '46',
  DROP_BOX_LABEL: '18',
  DROP_BOX_MESSAGE: '45',
  ESTIMATED_CHARGE_TOOLTIP: '48',
  ESTIMATED_DELIVERY_DATE_TOOLTIP: '47',
  EXCLUDED_TAX_COLUMN: '52',
  EXCLUDED_TAX_FOOTER: '50',
  EXCLUDED_TAX_PCC_PRICES: '51',
  HOSE_ASSEMBLY: '04',
  INCLUDED_TAX_COLUMN: '55',
  INCLUDED_TAX_FOOTER: '53',
  INCLUDED_TAX_PCC_PRICES: '54',
  NON_RETURNABLE_PART_NOTE: '05',
  PCC_AVAILABLE_TOOLTIP_DISCLAIMER: '34',
  PCC_EMERGENCY_MESSAGE: '31',
  PCC_RETURN_POLICY_MESSAGE: '32',
  PCC_TERMS_AND_CONDITIONS: '30',
  PCC_PRIVACY_POLICY: '29',
  REQUEST_BY_DATE_PART_AVAILABILITY: '44',
  STANDARD_ORDER_TYPE: '15',
  STOCK_ORDER_TYPE: '16'
};

export const messageFlagKey = {
  CREDIT_EXCEEDED: 'PCC_ECTCreditLimitFlag',
  DROP_BOX_ESTIMATED_PICKUP_DATE_TOOLTIP:
    'PCC_ECTDropBoxEstPickupDateTooltipFlag',
  ERP_OUTAGE_NOTIFICATION: 'PCC_ECTErpOutageMessage',
  ESTIMATED_CHARGE_TOOLTIP: 'PCC_ECTEstChargeTooltipFlag',
  ESTIMATED_DELIVERY_DATE_TOOLTIP: 'PCC_ECTEstDeliveryDateTooltipFlag',
  NON_RETURNABLE_PART_NOTE: 'PCC_ECTWarrantyAndReturnPolicy',
  PCC_AVAILABLE_TOOLTIP_DISCLAIMER: 'PCC_ECTAvailabilityTooltipFlag',
  PCC_EMERGENCY_MESSAGE: 'PCC_ECTEmergencyMessageFlag',
  PCC_PRIVACY_POLICY: 'PCC_ECTPrivacyPolicy',
  PCC_RETURN_POLICY_MESSAGE: 'PCC_ECTWarrantyAndReturnPolicy',
  PCC_TERMS_AND_CONDITIONS: 'PCC_ECTTermsAndConditions',
  REQUEST_BY_DATE_PART_AVAILABILITY: 'PCC_ECTRbdPrecedesPartAvlMsgFlag'
};

export const PCC_AVAILABLE_TOOLTIP_DISCLAIMER_TYPE =
  'PCC_AVAILABLE_TOOLTIP_DISCLAIMER';
